import React, { useMemo, useRef, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { useFormInput } from 'src/hooks'
import PropTypes from 'prop-types'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import FormControl from '@material-ui/core/FormControl'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Avatar from '@material-ui/core/Avatar'
import MuiAlert from '@material-ui/lab/Alert'
import Typography from '@material-ui/core/Typography'
import {
  Send, Paperclip, Trash2, File, Download,
} from 'react-feather'
import moment from 'moment-jalaali'
import { useDispatch } from 'react-redux'
import { rest } from 'lodash'
import { makeStyles } from '@material-ui/core'
import { answer, ask } from '../../app/slices/ticketsSlice'
import useStyle from './Styles'

// import { IMAGE_BASE_URL } from '../../api'

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '40px',
    },
    '& .MuiAvatar-img': {
      // width: '80%',
      // height: '80%',
    },
  },
  linkButton: {
    marginBottom: 10,
  },
  myInput: {
    borderRadius: '40px',
  },
}))

export const ChatBox = ({
  chat = [], id = 0, showInput = true, selectedTicket = {}, isUser = false, userPhoto = null,
}) => {
  const classes = useStyles()
  const chatsContainer = useRef(null)
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (chatsContainer.current) {
      chatsContainer.current.scrollTop = chatsContainer.current.scrollHeight
    }
  }, [chatsContainer, chat])

  React.useEffect(() => {
    if (chat.length > 0) {
      chatsContainer.current.style.scrollBehavior = 'smooth'
    }
  }, [chat])

  const handleNewComment = (textMessage) => {
    if (isUser) {
      dispatch(ask(selectedTicket.id, textMessage))
    } else {
      dispatch(answer({
        id: selectedTicket.id,
        answer: textMessage.question,
        file: textMessage.file,
      }))
    }
  }

  return (
    <Grid container direction="column" className={classes.root}>
      <Chats ele={chatsContainer} chats={chat} id={id} userPhoto={userPhoto} />
      { showInput && (
      <TextInput
        handleSubmit={handleNewComment}
        chatsContainerElement={chatsContainer}
      />
      ) }
    </Grid>
  )
}

ChatBox.prototype = {
  chat: PropTypes.array,
  id: PropTypes.number,
  showInput: PropTypes.bool,
  isUser: PropTypes.bool,
  selectedTicket: PropTypes.object,
}

function Alert({ onDelete = () => {}, text = '' }) {
  const classes = useStyle()
  return (
    <Grid className={classes.alertholder} container>
      <MuiAlert
        elevation={6}
        variant="filled"
        severity="info"
        className={classes.alert}
        icon={<Paperclip fontSize="inherit" />}
        action={(
          <IconButton onClick={onDelete} color="inherit" size="small">
            <Trash2 />
          </IconButton>
        )}
        {...rest}
      >
        {text}
      </MuiAlert>
    </Grid>
  )
}

Alert.prototype = {
  onDelete: PropTypes.func,
  text: PropTypes.string,
}

export const TextInput = ({ handleSubmit = () => {}, chatsContainerElement = {} }) => {
  const classes = useStyle()
  const text = useFormInput()
  const [file, setFile] = useState()

  const onSubmit = (event) => {
    event.preventDefault()
    chatsContainerElement.current.scrollTop = chatsContainerElement.current.scrollHeight

    const value = {
      question: text.value,
    }

    if (file) {
      value.file = file
    }

    if (text.value || file) handleSubmit(value)
    text.onChange({ target: { value: '' } })
    setFile(null)
  }

  return (
    <Grid container className={classes.inputText}>
      <form className={classes.form} onSubmit={onSubmit}>
        <FormControl variant="outlined" style={{ borderRadius: '20px' }} className={classes.form}>
          {file && (
          <Alert onDelete={() => setFile(null)} text={file.name} />
          )}
          <OutlinedInput
            classes={{ root: classes.input }}
            {...text}
            placeholder="پاسخ خود را تایپ کنید"
            InputProps={{
            }}
            size="small"
            endAdornment={(
              <InputAdornment position="end">
                {!file && (
                <IconButton className={classes.fileInputButton} aria-label="send">
                  <Paperclip />
                  <input onChange={(e) => setFile(e.target.files[0])} type="file" className={classes.fileInput} />
                </IconButton>
                )}
                <IconButton onClick={onSubmit} aria-label="send">
                  <Send />
                </IconButton>
              </InputAdornment>
          )}
          />
        </FormControl>
      </form>
    </Grid>
  )
}

TextInput.prototype = {
  handleSubmit: PropTypes.func,
}

const Chats = ({
  chats = [], id = 0, ele = {}, userPhoto = null,
}) => {
  const classes = useStyle()
  return (
    <Grid ref={ele} className={classes.chatContainer}>
      {chats.map((item) => (
        <ChatBubble key={item.id} id={id} chat={item} userPhoto={userPhoto} />
      ))}
    </Grid>
  )
}

Chats.prototype = {
  chats: PropTypes.array,
  id: PropTypes.number,
  ele: PropTypes.object,
}

const ChatBubble = ({ chat = {}, id = 0, userPhoto = null }) => {
  const classes = useStyle()
  const mine = id === chat.responder.userId
  const date = moment(chat.createDate)
  const faDate = date.format('jYYYY/jMM/jDD')

  console.log(id)

  const file = useMemo(() => {
    return chat.file
  }, [chat])
  return (
    <Grid container justify={mine ? 'flex-start' : 'flex-end'}>
      <div className={`${classes.ChatBubbleContainer} ${mine ? classes.row : classes.rowReverse}`}>
        {/* <Avatar className={classes.orange}
        src={id === chat.responder.userId && userPhoto} /> */}

        {/* <img
          alt="avatar"
          className={classes.orange}
          style={{ width: '40px', height: '40px', borderRadius: '50%' }}
          src={id === chat.responder.userId ? userPhoto : `${window.location.origin}/logo512.png`}
        /> */}

        <Avatar
          className={classes.orange}
          // style={{ width: '80%', height: '80%' }}
          src={id === chat.responder.userId
            ? userPhoto : `${window.location.origin}/logo512.png`}
        />

        <div className={classes.chatItemContainer}>
          <div className={`${classes.ChatBubble} ${mine ? classes.mine : classes.other}`}>
            {file && <FileDisplay file={file} />}
            <Typography className={classes.ChatBubbleText} variant="body1">
              {chat.comment && chat.comment !== 'undefined' ? chat.comment : null}
            </Typography>
          </div>
          <Typography className={classes.dateHolder} variant="caption">
            {faDate}
          </Typography>
        </div>
      </div>
    </Grid>
  )
}
ChatBubble.prototype = {
  chat: PropTypes.object,
  id: PropTypes.number,
}

const FileDisplay = ({ file }) => {
  const classes = useStyle()

  const isImage = useMemo(() => {
    return file.mimeType?.includes('image')
  }, [file])

  // const url = useMemo(() => IMAGE_BASE_URL + file.url, [file])
  const url = file?.url

  const faDate = useMemo(() => (
    moment(file.createDate)?.format('jYYYY/jMM/jDD')
  ), [file])

  const handleImageError = (event) => {
    const { target } = event
    console.log(target)
    target.style.opacity = 0
  }

  console.log(url)

  if (isImage) {
    return (
      <div className={classes.fileContainer}>
        <a href={url} download={`file-${file.id}.png`} id={file.id}>
          <IconButton className={classes.downloadButton}>
            <Download size="18px" color="#fff" />
          </IconButton>
        </a>
        <img
          onError={handleImageError}
          className={classes.fileImage}
          src={url}
          alt={file.createDate}
        />
      </div>
    )
  }
  return (
    <div>
      <a href={url} download={`file-${file.id}.png`} id={file.id}>
        <div className={classes.otherFiles}>
          <IconButton id={`download-file-button-${file.id}`} className={classes.fileDownloadButton}>
            <label htmlFor={`download-file-button-${file.id}`}>{`${faDate}-${file.mimeType}`}</label>
            <File />
          </IconButton>
        </div>
      </a>
    </div>
  )
}
FileDisplay.prototype = {
  file: PropTypes.object,
}

export default ChatBox
